import React from "react";
import l from "components/util/l";
import VersionList from "components/studio/rightnav/versions/VersionList";


const VersionsView = ({ flow }) =>
  <div id="versions" className="px-2">
    <div className="w-100 px-3 px-sm-4">
      <div className="row h-100">
        <div className="col-lg-12 mb-4" >
          <h2 className="mb-4 mt-1">{l("Versiones%SA171")}</h2>

          <VersionList
            flow={flow}
            placeholder={l("No hay versiones%SA172")}
          />

        </div>
      </div>
    </div>
  </div>


export default VersionsView;